import {CouponQueueDetailDto} from 'rest'
import {CouponType, CouponOffers} from './coupon.enum'
import formatNumber from './formatNumber'

const DEFAULT_COUPON_OFFER: string[] = ['', 'Sale', '', '']

export const parseCouponTitle = (
  coupon: Partial<CouponQueueDetailDto> & {currency?: string}
): string[] => {
  const {typeId, isSavingsRange, savings, currency = '$'} = coupon

  const defaultPrefix = isSavingsRange ? 'UP TO' : ''

  CouponOffers[CouponType.OFFER_TYPE_SALE_PERCENT] = [
    defaultPrefix,
    `${formatNumber(savings)}%`,
    'OFF',
    'percent',
  ]
  CouponOffers[CouponType.OFFER_TYPE_SITE_WIDE_PERCENT] = [
    defaultPrefix,
    `${formatNumber(savings)}%`,
    'OFF',
    'percent',
  ]
  CouponOffers[CouponType.OFFER_TYPE_SALE_AMOUNT] = [
    defaultPrefix,
    `${currency}${formatNumber(savings)}`,
    'OFF',
    'amount',
  ]
  CouponOffers[CouponType.OFFER_TYPE_SITE_WIDE_AMOUNT] = [
    defaultPrefix,
    `${currency}${formatNumber(savings)}`,
    'OFF',
    'amount',
  ]

  // CouponOffers is keyed by string offer types (e.g. 'sale percent'), not
  // numeric indices — CouponOffers[0] is always undefined. Fall back to Other
  // when the API returns an offer_type the UI map does not cover.
  return (
    (typeId != null ? CouponOffers[typeId as keyof typeof CouponOffers] : undefined) ||
    CouponOffers[CouponType.OFFER_TYPE_OTHER] ||
    DEFAULT_COUPON_OFFER
  )
}
